export default __webpack_public_path__ + "ddd6540c27fb92ec3070a20e8619d6bb.png";